// for unassigment of employee
export const RESET_ADD_ACH_BANK_INFO = "resign_ADD_ACH_BANK_INFO";
export const ADD_ACH_BANK_INFO = "ADD_ACH_BANK_INFO";
export const ADD_ACH_BANK_INFO_SUCCESS = "ADD_ACH_BANK_INFO_success";
export const ADD_ACH_BANK_INFO_FAILURE = "ADD_ACH_BANK_INFO_failure";
